import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { RepairFacility } from "./models/repair-facility";
import { catchError, map } from "rxjs/operators";
import { RepairFacilityMapper } from "./mappers/repair-facility.mapper";
import { ContactMapper } from "./mappers/contact.mapper";
import { UserContact } from "./models/user-contact";

// Defines methods used to retrieve user data from the API.
export interface IUserService {
	/**
	 * Gets repair facilities associated with the current user.
	 * @returns A list of repair facilities associated with the current user.
	 * @see RepairFacility
	 */
	getRepairFacilities(): Observable<RepairFacility[]>;

	/**
	 * Gets contacts associated with the current user.
	 * @returns A list of contacts associated with the current user.
	 * @see UserContact
	 */
	getContacts(): Observable<UserContact[]>;
}

@Injectable({
	providedIn: 'root'
})
export class UserService implements IUserService {

	public baseContractManagementUrl = environment.baseClaimSubmissionUrl;
	public httpClient: HttpClient;

	constructor(http: HttpClient) {
		this.httpClient = http;
	}

	public getRepairFacilities(): Observable<RepairFacility[]> {
		const url = `${this.baseContractManagementUrl}/user/repair-facilities`;

		const httpOptions = {
			headers: new HttpHeaders({
				'Accept': 'application/json',
				'reportProgress': 'true',
				'observe': 'events',
				'timeout': '90000',
			}),
		}

		return this.httpClient.get(url, httpOptions)
			.pipe(
				map(response => {
					return (response as []).map(RepairFacilityMapper.mapUserRepairFacility);
				}),
				catchError((error) => {
					return throwError(() => new Error(error));
				})
			);
	}

	public getContacts(): Observable<UserContact[]> {
		const url = `${this.baseContractManagementUrl}/user/contacts`;

		const httpOptions = {
			headers: new HttpHeaders({
				'Accept': 'application/json',
				'reportProgress': 'true',
				'observe': 'events',
				'timeout': '90000',
			}),
		}

		return this.httpClient.get(url, httpOptions)
			.pipe(
				map(response => {
					return (response as []).map(ContactMapper.mapContact);
				}),
				catchError((error) => {
					return throwError(() => new Error(error));
				})
			);
	}
}